import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UiJsonFormatterModule } from '@components/ui-json-formatter/ui-json-formatter.module';
import { SharedModule } from '@modules/shared.module';
import { UiGridResetModule } from '@pages/generics/grid/grid-reset';
import { UiGridModule } from '@uipath/angular/components/ui-grid';
import { UiDateFormatModule } from '@uipath/angular/directives/ui-dateformat';
import { UiNgLetModule } from '@uipath/angular/directives/ui-ng-let';

import { LogsPageComponent } from './logs.page';
import { LogDetailsModalComponent } from './modals';

const MODALS = [
    LogDetailsModalComponent,
];

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        UiGridModule,
        UiGridResetModule,
        UiJsonFormatterModule,
        UiNgLetModule,
        UiDateFormatModule,
    ],
    declarations: [
        LogsPageComponent,
        ...MODALS,
    ],
    exports: [
        LogsPageComponent,
    ],
    entryComponents: [
        ...MODALS,
    ],
})
export class LogModule { }
